import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type ChevronRightIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const ChevronRightIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.gray.light250,
  ...props
}: ChevronRightIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 16L14 12L10 8"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
